/**
 * iOS Safari auto-zooms into any focused `<input>` whose computed font-size is
 * below 16px. Our inputs render at ~12px on phones (Figma design), so focusing a
 * field on iPhone Safari would zoom the page in. Pinning `maximum-scale=1` +
 * `user-scalable=no` on the viewport meta suppresses that zoom (and disables
 * pinch-zoom — an accepted trade-off for this app-like web build).
 *
 * Done at runtime rather than in the HTML template because the Expo web build
 * emits its own `index.html`; patching the existing meta keeps a single source
 * of truth regardless of the template.
 */
const VIEWPORT_CONTENT =
  'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, shrink-to-fit=no';

export function lockViewportZoom(): void {
  if (typeof document === 'undefined') return;

  let meta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = 'viewport';
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', VIEWPORT_CONTENT);
}
